"use strict";
export { Separator, SeparatorPropsProvider } from './separator.js';
